import React, { useEffect, useState } from "react";
import { ASSETTRANSFER_API, DEPARTMENT_API, ASSET_API } from "@app/utils/apiUrl";
import { Post, Get } from "@app/utils/httpProvider";
import Table from "react-bootstrap/Table";

const AccessoryHistoryTab = ({ assetId }) => {
    const [historyList, setHistoryList] = useState([]);

    useEffect(() => {
        if (!assetId) return;

        const fetchHistoryData = async () => {
            try {
                const [resTransfer, resDepartment, resAsset] =
                    await Promise.all([
                        Get(`${ASSETTRANSFER_API.GET_BY_ASSET_ID}/${assetId}`),
                        Get(`${DEPARTMENT_API.GET_ALL}`),
                        Get(`${ASSET_API.GET_ITEM}/${assetId}`)
                    ]);

                // Map dữ liệu để bind ra UI
                const mappedData = resTransfer.map((transfer) => {
                    // 1. Lấy ID an toàn (ưu tiên viết hoa, nếu không có thì lấy viết thường)
                    const fromId = transfer.FromDepartmentId || transfer.fromDepartmentId;
                    const toId = transfer.ToDepartmentId || transfer.toDepartmentId;

                    // 2. Tìm kiếm an toàn bằng cách lấy ID của department ra so sánh
                    const fromDept = resDepartment.find(d => (d.Id || d.id) === fromId);
                    const toDept = resDepartment.find(d => (d.Id || d.id) === toId);

                    // 3. Xử lý dữ liệu tài sản tương tự để tránh lỗi
                    const assetInfo = Array.isArray(resAsset) ? resAsset[0] : resAsset;

                    return {
                        id: transfer.Id || transfer.id,
                        assetCode: assetInfo?.AssetCode || assetInfo?.assetCode || "",
                        assetName: assetInfo?.AssetName || assetInfo?.assetName || "",
                        transferDate: transfer.TransferDate || transfer.transferDate || "",
                        fromDepartmentName: fromDept?.DepartmentName || fromDept?.departmentName || "",
                        toDepartmentName: toDept?.DepartmentName || toDept?.departmentName || "",
                        requestedBy: transfer.RequestedBy || transfer.requestedBy || "",
                        status: transfer.Status || transfer.status || ""
                    };
                });

                setHistoryList(mappedData);

            } catch (error) {
                console.error("Lỗi khi lấy dữ liệu lịch sử điều chuyển:", error);
            }
        };

        fetchHistoryData();
    }, [assetId]);

    // Hàm xử lý render UI trạng thái (Màu sắc và Icon chuẩn)
    const renderStatusBadge = (status) => {
        let bgColor = "#6c757d";
        let icon = "fa-info-circle";
        let textColor = "text-white";
        let displayText = status;

        if (status === 'Đã duyệt' || status === 'Đã hoàn thành' || status === 'Đã điều chuyển') {
            bgColor = "#20c997"; // Xanh lá
            icon = "fa-check-circle";
            displayText = status === 'Đã điều chuyển' ? 'Đã hoàn thành' : status;
        } else if (status === 'Không phê duyệt' || status === 'Từ chối') {
            bgColor = "#f05050"; // Đỏ
            icon = "fa-times-circle";
            displayText = 'Không phê duyệt';
        } else if (status === 'Đang sửa chữa') {
            bgColor = "#4285f4"; // Xanh dương
            icon = "fa-wrench";
        } else if (status === 'Chờ phê duyệt') {
            bgColor = "#ffc107"; // Vàng
            textColor = "text-dark";
            icon = "fa-clock";
            displayText = 'Chờ phê duyệt';
        }

        return (
            <span
                className={`badge ${textColor} px-2 py-2 d-inline-flex align-items-center justify-content-center`}
                style={{
                    backgroundColor: bgColor,
                    fontSize: '11px',
                    borderRadius: '6px',
                    fontWeight: 700,
                    minWidth: '120px',
                    height: '24px',
                }}
            >
                <i className={`fas ${icon}`} style={{ marginRight: '4px', fontSize: '10px' }}></i>
                <span style={{ textTransform: 'uppercase' }}>{displayText}</span>
            </span>
        );
    };

    return (
        <div className="">
            <div className="d-flex justify-content-between align-items-center mb-3">
                <h6 className="mb-0 text-primary">Lịch sử điều chuyển</h6>
            </div>

            {/* Desktop View */}
            <div className="table-responsive d-none d-md-block">
                <Table striped bordered hover size="sm">
                    <thead>
                        <tr>
                            <th className="text-center" style={{ width: "60px" }}>STT</th>
                            <th>Mã tài sản</th>
                            <th>Tên tài sản</th>
                            <th>Ngày điều chuyển</th>
                            <th>Nơi đi</th>
                            <th>Nơi đến</th>
                            <th>Người điều chuyển</th>
                            <th className="text-center">Trạng thái</th>
                        </tr>
                    </thead>

                    <tbody>
                        {historyList.length === 0 && (
                            <tr>
                                <td colSpan="8" className="text-center text-muted py-3">
                                    Chưa có lịch sử điều chuyển
                                </td>
                            </tr>
                        )}
                        {historyList.map((item, index) => {
                            return (
                                <tr key={item.id || index}>
                                    <td className="text-center align-middle">{index + 1}</td>
                                    <td className="align-middle">{item.assetCode}</td>
                                    <td className="align-middle">{item.assetName}</td>
                                    <td className="align-middle">
                                        {item.transferDate ? new Date(item.transferDate).toLocaleDateString('vi-VN') : ''}
                                    </td>
                                    {/* Đã sửa lỗi typo item.fromDDepartmentName ở code cũ */}
                                    <td className="align-middle">{item.fromDepartmentName}</td>
                                    <td className="align-middle">{item.toDepartmentName}</td>
                                    <td className="align-middle">{item.requestedBy}</td>
                                    <td className="text-center align-middle">
                                        {renderStatusBadge(item.status)}
                                    </td>
                                </tr>
                            );
                        })}
                    </tbody>
                </Table>
            </div>

            {/* Mobile View */}
            <div className="d-block d-md-none">
                {historyList.length === 0 && (
                    <div className="text-center py-4 text-muted bg-light rounded border">
                        <i className="fas fa-history fa-2x mb-2 d-block text-secondary" />
                        Chưa có lịch sử điều chuyển
                    </div>
                )}
                {historyList.map((item, index) => (
                    <div 
                        key={item.id || index} 
                        className="card mb-3 shadow-sm border rounded transfer-card"
                        style={{
                            borderLeft: '4px solid #17a2b8',
                            backgroundColor: '#ffffff'
                        }}
                    >
                        <div className="card-body p-3">
                            <div className="d-flex justify-content-between align-items-start mb-2">
                                <div>
                                    <span className="text-muted small fw-bold mr-2">#{index + 1}</span>
                                    <strong className="text-dark" style={{ fontSize: '15px' }}>{item.assetName || 'Tài sản'}</strong>
                                    <div className="text-muted small mt-1">
                                        <i className="fas fa-barcode mr-1" /> Mã: {item.assetCode}
                                    </div>
                                </div>
                                {renderStatusBadge(item.status)}
                            </div>
                            <hr className="my-2" style={{ borderColor: '#f1f3f5' }} />
                            <div className="row g-2 text-muted small mb-1">
                                <div className="col-12 mb-1">
                                    <i className="fas fa-sign-out-alt mr-1 text-danger" /> <strong>Nơi đi:</strong> {item.fromDepartmentName || '-'}
                                </div>
                                <div className="col-12 mb-1">
                                    <i className="fas fa-sign-in-alt mr-1 text-success" /> <strong>Nơi đến:</strong> {item.toDepartmentName || '-'}
                                </div>
                                <div className="col-6">
                                    <i className="fas fa-calendar-alt mr-1" /> <strong>Ngày đi:</strong> {item.transferDate ? new Date(item.transferDate).toLocaleDateString('vi-VN') : ''}
                                </div>
                                <div className="col-6">
                                    <i className="fas fa-user mr-1" /> <strong>Người gửi:</strong> {item.requestedBy || '-'}
                                </div>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default AccessoryHistoryTab;